import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Actions = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
`
